import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, isRef as _isRef, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59fd2206"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "MCaracteristicaValor",
  "data-testid": "MCaracteristicaValor"
}
const _hoisted_2 = { class: "MCaracteristicaValor__Chip" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "MCaracteristicaValor__Obrigatorio" }, "*", -1))
const _hoisted_4 = { class: "MAtributoComValor__Valor" }

import Chip from "primevue/chip"
  import {
    MCalendario,
    MDropdown,
    MInput,
    MEntradaNumerica,
    MMultiSelect,
  } from "@/components/Gerais"
  import Textarea from "primevue/textarea"
  import { computed } from "vue"
  import { TiposPossiveis } from "@/types/atributo"
  import { TipoDoValorParaComponente } from "./OCaracteristicaValor.interface"
  import { ValorDoAtributo } from ".."
  import { Anulavel } from "@/types/gerais"

  type ModeloValor = ValorDoAtributo
  interface Props {
    nome?: string
    tipoDeValor: Anulavel<TiposPossiveis>
    modelValue: ModeloValor
    valoresPossiveis?: string[]
    listaDeMultiplaEscolha?: boolean
    obrigatorio?: boolean
    desabilitarCampo?: boolean
    modoLeitura?: boolean
  }

  type Componente =
    | typeof MDropdown
    | typeof MInput
    | typeof MEntradaNumerica
    | typeof MMultiSelect
    | typeof MCalendario

  type EmitirModel = {
    (event: "update:modelValue", modelValue: ModeloValor): void
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'OCaracteristicaValor',
  props: {
    nome: null,
    tipoDeValor: null,
    modelValue: null,
    valoresPossiveis: null,
    listaDeMultiplaEscolha: { type: Boolean },
    obrigatorio: { type: Boolean },
    desabilitarCampo: { type: Boolean },
    modoLeitura: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: emitir }: { emit: ({
    (event: "update:modelValue", modelValue: ModeloValor): void
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    nome?: string
    tipoDeValor: Anulavel<TiposPossiveis>
    modelValue: ModeloValor
    valoresPossiveis?: string[]
    listaDeMultiplaEscolha?: boolean
    obrigatorio?: boolean
    desabilitarCampo?: boolean
    modoLeitura?: boolean
  }

  

  

  const emitirModel = computed({
    get(): ModeloValor {
      return props.modelValue
    },
    set(value: ModeloValor) {
      emitir("update:modelValue", value)
    },
  })
  const mapearTipoDeValorParaComponente: TipoDoValorParaComponente<Componente> =
    {
      numero_inteiro: {
        componente: MEntradaNumerica,
        className: "MCaracteristica__MEntradaNumerica",
        props: {
          combinado: false,
          idParaTestes: "MCaracteristica__MEntradaNumerica",
        },
      },
      numero_decimal: {
        componente: MEntradaNumerica,
        className: "MCaracteristica__MEntradaNumerica",
        props: {
          combinado: true,
          modo: "decimal",
          minFracaoDigitos: 2,
          maxFracaDigitos: 2,
          idParaTestes: "MCaracteristica__MEntradaNumerica",
        },
      },
      codigo_identificador: {
        componente: MInput,
        className: "MCaracteristica__MInput",
        props: {
          dataTestid: "MCaracteristica__MInput",
        },
      },
      texto: {
        componente: MInput,
        className: "MCaracteristica__MInput",
        props: {
          modelValue: props.modelValue,
          dataTestid: "MCaracteristica__MInput",
        },
      },
      opcao: {
        componente: MDropdown,
        className: "MCaracteristica__MDropdown",
        props: {
          options: props.valoresPossiveis,
          dataTestid: "MCaracteristica__MDropdown",
        },
      },
      data: {
        componente: MCalendario,
        className: "MCaracteristica__MCalendar",
        props: {
          dataFormato: "dd.mm.yy",
          dataTestid: "MCaracteristica__MCalendar",
        },
      },
      horario: {
        componente: MCalendario,
        className: "MCaracteristica__MCalendario",
        props: {
          formatoHora: "24",
          somenteHora: true,
          dataTestid: "MCaracteristica__MCalendario",
        },
      },
      itens_de_lista: {
        componente: MMultiSelect,
        className: "MCaracteristica__MMultiSelect",
        props: {
          options: props.valoresPossiveis,
          dataTestid: "MCaracteristica__MMultiSelect",
        },
      },
  }

  const definirComponentePorTipoDeValor = computed(() => {
    const componenteBase = mapearTipoDeValorParaComponente[props.tipoDeValor!]

    // A ideia é que no modo leitura, alguns componentes mudem para facilitar a visualização dos itens
    if (props.modoLeitura) {
      if (props.tipoDeValor === "itens_de_lista") {
        
        return {
          componente: MDropdown,
          className: "MCaracteristica__MDropdown",
          props: {
            options: props.valoresPossiveis,
            modelValue: props.valoresPossiveis?.[0],
            dataTestid: "MCaracteristica__MDropdown",
          },
        }
      }

      if (props.tipoDeValor === "texto") {
        return {
          componente: Textarea,
          className: "MCaracteristica__Textarea",
          props: {
            modelValue: props.modelValue,
            dataTestid: "MCaracteristica__Textarea",
          },
        }
      }
    }
    return componenteBase
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_unref(Chip), {
        class: "MCaracteristicaValor__Chip__Label",
        label: __props.nome
      }, null, 8, ["label"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(definirComponentePorTipoDeValor).componente), _mergeProps({
        modelValue: _unref(emitirModel),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(emitirModel) ? (emitirModel).value = $event : null)),
        class: ["MCaracteristica__Componente", [
          _unref(definirComponentePorTipoDeValor).className,
          { 'MCaracteristica__Componente--desabilitado': __props.desabilitarCampo }
        ]]
      }, _unref(definirComponentePorTipoDeValor).props, { nome: __props.nome }), null, 16, ["modelValue", "class", "nome"]))
    ])
  ]))
}
}

})